<template lang="pug">
  .loading
    Logo(ref="logo")
</template>

<script>
import Logo from '@/components/wedgits/Logo'
export default {
  name: 'Loading',
  components: { Logo },
  mounted() {},
  methods: {
    load() {
      console.log(this.$refs.logo)
      let rect = this.$refs.logo.$el.getBoundingClientRect()
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(rect)
        }, 2000)
      })
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.loading
  +full
  .logo
    position: absolute
    left: pxToRem((750-259)/2-177)
    top: pxToRem(90)
</style>
